/* Delay the first approved opening; keep the original image geometry and home link. */
(function () {
  'use strict';
  if (window.__asmLogoMotionReady) return;
  window.__asmLogoMotionReady = true;
  var touch = window.matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)');
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)');
  var START_DELAY = 0, DURATION = 1000, startAt = 0;
  var prepared = new WeakSet(), pending = new Map(), active = new Map();

  function cancelPending(mark) {
    var entry = pending.get(mark);
    if (!entry) return;
    window.clearTimeout(entry.timer);
    entry.image.removeEventListener('load', entry.start);
    entry.image.removeEventListener('error', entry.fail);
    pending.delete(mark);
  }
  function restore(mark) {
    var entry = active.get(mark);
    if (!entry) return;
    window.clearTimeout(entry.timer);
    entry.layer.removeEventListener('animationend', entry.finish);
    if (entry.addedLabel) entry.link.removeAttribute('aria-label');
    mark.classList.remove('asm-logo-motion');
    entry.layer.remove();
    active.delete(mark);
  }
  function stop() {
    pending.forEach(function (_, mark) { cancelPending(mark); });
    active.forEach(function (_, mark) { restore(mark); });
  }
  function play(mark, image) {
    if (!touch.matches || reduced.matches || !mark.isConnected || !image.naturalWidth) return;
    var link = mark.closest('a');
    var addedLabel = link && !link.hasAttribute('aria-label') && image.alt;
    if (addedLabel) link.setAttribute('aria-label', image.alt);
    var layer = document.createElement('span');
    layer.className = 'asm-logo-motion__reveal';
    layer.setAttribute('aria-hidden', 'true');
    var copy = image.cloneNode(true);
    copy.removeAttribute('id');
    copy.removeAttribute('fetchpriority');
    copy.alt = '';
    layer.appendChild(copy);
    function finish(event) {
      if (event.target === layer && event.animationName === 'asm-logo-reveal-v96') restore(mark);
    }
    active.set(mark, { layer: layer, finish: finish, timer: 0, link: link, addedLabel: addedLabel });
    layer.addEventListener('animationend', finish);
    mark.appendChild(layer);
    mark.classList.add('asm-logo-motion');
    active.get(mark).timer = window.setTimeout(function () { restore(mark); }, DURATION + 100);
  }
  function init(scope) {
    if (!startAt || !touch.matches || reduced.matches) return;
    scope.querySelectorAll('.section-header .header__heading-logo-wrapper').forEach(function (mark) {
      if (prepared.has(mark)) return;
      var image = mark.querySelector('img.header__heading-logo');
      if (!image || (image.complete && !image.naturalWidth)) return;
      prepared.add(mark);
      var entry = { image: image, timer: 0, start: null, fail: null };
      function start() {
        if (pending.get(mark) !== entry) return;
        if (!touch.matches || reduced.matches || !mark.isConnected) { cancelPending(mark); return; }
        if (Date.now() < startAt || !image.complete || !image.naturalWidth) return;
        cancelPending(mark);
        play(mark, image);
      }
      entry.start = start;
      entry.fail = function () { cancelPending(mark); };
      pending.set(mark, entry);
      image.addEventListener('load', entry.start);
      image.addEventListener('error', entry.fail);
      entry.timer = window.setTimeout(start, Math.max(0, startAt - Date.now()));
    });
  }
  function pageReady() {
    startAt = Date.now() + START_DELAY;
    init(document);
  }
  function preferencesChanged() {
    if (!touch.matches || reduced.matches) stop();
    else init(document);
  }
  [touch, reduced].forEach(function (query) {
    if (query.addEventListener) query.addEventListener('change', preferencesChanged);
    else if (query.addListener) query.addListener(preferencesChanged);
  });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { stop(); prepared = new WeakSet(); pageReady(); }
  });
  document.addEventListener('shopify:section:load', function () { init(document); });
  if (document.readyState === 'complete') pageReady();
  else document.addEventListener('DOMContentLoaded', pageReady, { once: true });
})();
